import React, { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";

import InvestmentUserDataStep from "./InvestmentUserDataStep";
import InvestmentCalculationStep from "./InvestmentCalculationStep";
import InvestmentOverviewStep from "./InvestmentOverviewStep";
import { investmentProcessSteps } from "constants/index";
import { RenderAdequacyStep } from "components/AdequacyModal";

import { selectInvestmentStepData, selectIsInvestmentFailed } from "store/user/investment/selectors";
import { selectAdequacyStep, selectAdequacyIsAccepted } from "store/user/adequacy/selectors";
import { userDashboardDetailsSuccess } from "store/user/account/actions";

import { setInvestmentStepData, clearInvestmentStepData } from "store/user/investment/actions";
import { setAdequacyStart } from "store/user/adequacy/actions";

export const RenderInvestmentPersonalStep = ({
    investmentStepData,
    investmentSectionStep,
    adequacyStep,
    isAccepted,
    userDashboardDetailsSuccess,
    setInvestmentStepData,
    kycCompleted,
    setAdequacyStart,
    adequacyCompleted,
    onCloseButtonClick,
    setInvestmentKycModalFlag,
    hideInvestmentModal,
    userEmail,
    openInvestment,
    open,
    backSlideEffect = "",
    setBackSlideEffect,
    investmentProcessBack,
    setInvestmentProcessBack,
    isGfkOnboardingProduct,
    isEwPgInvestmentProcess,
    productCatalog,
    productType,
}) => {
    const [backButton, setBackButton] = useState(false);

    const investSum = investmentStepData.investSum;

    const hitBack = () => {
        setBackButton(false);
        setInvestmentProcessBack();
    };

    useEffect(() => {
        if (investmentProcessBack) {
            setBackButton(true);
        }
    }, [investmentProcessBack]);

    function renderInvestmentPersonalStep() {
        switch (investmentSectionStep) {
            case "investmentUserDataStep":
                return (
                    <InvestmentUserDataStep
                        backSlideEffect={backSlideEffect}
                        setBackSlideEffect={setBackSlideEffect}
                        onCloseButtonClick={onCloseButtonClick}
                        backButton={backButton}
                        hitBack={hitBack}
                        open={open}
                    />
                );
            case "renderAdequacyStep":
                return (
                    <RenderAdequacyStep
                        adequacyBack={backButton}
                        setAdequacyBack={hitBack}
                        isAccepted={isAccepted}
                        investSum={investSum}
                        isWithInvestment
                        step={adequacyStep}
                        kycCompleted={kycCompleted}
                        adequacyCompleted={adequacyCompleted}
                        setInvestmentStepData={setInvestmentStepData}
                        setAdequacyStart={setAdequacyStart}
                        userDashboardDetailsSuccess={userDashboardDetailsSuccess}
                        open={open}
                        onCloseButtonClick={onCloseButtonClick}
                        adequacyFrom={"investment"}
                    />
                );
            case "investmentCalculationStep":
                return (
                    <InvestmentCalculationStep
                        backSlideEffect={backSlideEffect}
                        setBackSlideEffect={setBackSlideEffect}
                        backButton={backButton}
                        hitBack={hitBack}
                    />
                );
            case "investmentOverviewStep":
                return (
                    <InvestmentOverviewStep
                        isGfkOnboardingProduct={isGfkOnboardingProduct}
                        isEwPgInvestmentProcess={isGfkOnboardingProduct ? false : isEwPgInvestmentProcess}
                        backSlideEffect={backSlideEffect}
                        setBackSlideEffect={setBackSlideEffect}
                        backButton={backButton}
                        hitBack={hitBack}
                        userEmail={userEmail}
                        hideInvestmentModal={hideInvestmentModal}
                        kycCompleted={kycCompleted}
                        setInvestmentKycModalFlag={setInvestmentKycModalFlag}
                        openInvestment={openInvestment}
                        productCatalog={productCatalog}
                        productType={productType}
                    />
                );
            default:
                return <InvestmentUserDataStep />;
        }
    }
    return renderInvestmentPersonalStep();
};

const InvestmentProcess = ({
    className = "",
    investmentSectionStep,
    investmentStepData,
    adequacyStep,
    investSum,
    isAccepted,
    setInvestmentStepData,
    adequacyCompleted,
    kycCompleted,
    clearInvestmentStepData,
    setAdequacyStart,
    userDashboardDetailsSuccess,
    onCloseButtonClick,
    setInvestmentKycModalFlag,
    hideInvestmentModal,
    userEmail,
    openInvestment,
    open,
    backSlideEffect = "",
    setBackSlideEffect,
    investmentProcessBack,
    setInvestmentProcessBack,
    isGfkOnboardingProduct,
    isEwPgInvestmentProcess,
    productCatalog,
    productType,
}) => {
    const memoizedRenderInvestmentPersonalStep = useMemo(() => {
        return (
            <RenderInvestmentPersonalStep
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                userEmail={userEmail}
                investmentProcessBack={investmentProcessBack}
                setInvestmentProcessBack={setInvestmentProcessBack}
                investmentSectionStep={investmentSectionStep}
                investmentStepData={investmentStepData}
                adequacyStep={adequacyStep}
                investSum={investSum}
                isAccepted={isAccepted}
                kycCompleted={kycCompleted}
                adequacyCompleted={adequacyCompleted}
                setInvestmentStepData={setInvestmentStepData}
                setAdequacyStart={setAdequacyStart}
                userDashboardDetailsSuccess={userDashboardDetailsSuccess}
                onCloseButtonClick={() => {
                    onCloseButtonClick && onCloseButtonClick();
                    clearInvestmentStepData && clearInvestmentStepData();
                }}
                setInvestmentKycModalFlag={setInvestmentKycModalFlag}
                hideInvestmentModal={hideInvestmentModal}
                clearInvestmentStepData={clearInvestmentStepData}
                openInvestment={openInvestment}
                open={open}
                isGfkOnboardingProduct={isGfkOnboardingProduct}
                isEwPgInvestmentProcess={isEwPgInvestmentProcess}
                productCatalog={productCatalog}
                productType={productType}
            />
        );
    }, [
        investmentSectionStep,
        investmentStepData,
        adequacyStep,
        investSum,
        kycCompleted,
        adequacyCompleted,
        userDashboardDetailsSuccess,
        investmentProcessBack,
        open,
    ]);

    return (
        <div className={`${className} investment-process-container investment-process`}>
            <div className="investment-process-steps flex">
                {investmentProcessSteps() &&
                    investmentProcessSteps().length > 0 &&
                    investmentProcessSteps().map(({ number, step, title }, stepIndex) => (
                        <div key={stepIndex} className={`${investmentSectionStep === step ? "active" : ""} single-step`}>
                            <span className="step-number">{number}</span>
                            <span className="step-title text-14 fw-600">{title}</span>
                        </div>
                    ))}
            </div>
            <div className="investment-steps">{memoizedRenderInvestmentPersonalStep}</div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    adequacyStep: selectAdequacyStep(state),
    isAccepted: selectAdequacyIsAccepted(state),
    investmentStepData: selectInvestmentStepData(state),
    investmentError: selectIsInvestmentFailed(state),
    investmentSectionStep: selectInvestmentStepData(state).investmentData.step,
});

const mapDispatchToProps = (dispatch) => ({
    setInvestmentStepData: (data) => dispatch(setInvestmentStepData(data)),
    setAdequacyStart: (data) => dispatch(setAdequacyStart(data)),
    clearInvestmentStepData: () => dispatch(clearInvestmentStepData()),
    userDashboardDetailsSuccess: (data) => dispatch(userDashboardDetailsSuccess(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentProcess);
